/**
 * Organization configuration requests.
 *
 * Nothing here targets a subscriptions endpoint despite the filename, which is kept so importers
 * do not have to change. Treat it as organization config.
 */
import queryString from 'query-string';

import request from 'utils/request';

export const API_BASE_URL = `${process.env.REACT_APP_BASE_URL_API}/api`;

// @ts-ignore
/**
 * Gets organization configuration settings
 *
 * @param params - Request parameters
 * @param params.organizationUuid - Organization UUID
 * @param params.storeUuid - Store UUID for the config request
 * @param options - Additional request options
 * @returns Organization config data
 */
export const getOrganizationConfigRequest = (
  { organizationUuid, storeUuid }: { organizationUuid: string; storeUuid: string },
  options = {},
) => {
  const query = queryString.stringify({ store_uuid: storeUuid });

  if (!organizationUuid || !storeUuid) {
    return null;
  }

  return request(`${API_BASE_URL}/v1/organizations/${organizationUuid}/config/?${query}`, {
    method: 'GET',
    ...options,
  });
};
